function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M81.019 70.105 81.019 62.364 78.019 62.364 78.019 69.7C72.508 69.011 66.453 68.505 60.019 68.223L60.019 60.364 57.019 60.364 57.019 68.112C54.091 68.0173 51.1 67.9687 48.046 67.966 44.9793 67.966 41.9703 68.0153 39.019 68.114L39.019 60.364 36.019 60.364 36.019 68.229C29.583 68.512 23.528 69.021 18.019 69.712L18.019 62.364 15.019 62.364 15.019 70.114C11.39 70.632 8.019 71.231 5.001 71.903L5.001 87 91 87 91 71.882C87.985 71.215 84.632 70.621 81.019 70.105Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.782 37.4C17.024 39.439 17.082 43.539 17.082 43.539 17.082 43.539 20.477 43.766 22.234 41.727 23.991 39.688 23.694 35.872 23.694 35.872 23.694 35.872 20.54 35.362 18.782 37.4Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.15 49.823C23.908 47.785 23.609 43.968 23.609 43.968 23.609 43.968 20.46 43.457 18.7 45.5 16.94 47.543 17 51.635 17 51.635 17 51.635 20.392 51.862 22.15 49.823Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9 43.557C15.9 43.557 16.034 39.457 14.316 37.465 12.598 35.473 9.437 36.076 9.437 36.076 9.437 36.076 9.063 39.903 10.782 41.892 12.501 43.881 15.9 43.557 15.9 43.557Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.824 51.652C15.824 51.652 15.958 47.552 14.24 45.56 12.522 43.568 9.362 44.172 9.362 44.172 9.362 44.172 8.988 48 10.706 49.987 12.424 51.974 15.824 51.652 15.824 51.652Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.158 57.9C23.916 55.861 23.617 52.045 23.617 52.045 23.617 52.045 20.468 51.534 18.71 53.573 16.952 55.612 17.01 59.712 17.01 59.712 17.01 59.712 20.4 59.935 22.158 57.9Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.37 52.245C9.37 52.245 9 56.071 10.714 58.06 12.428 60.049 15.832 59.725 15.832 59.725 15.832 59.725 15.967 55.625 14.248 53.633 12.529 51.641 9.37 52.245 9.37 52.245Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.983 35.461C15.983 35.461 16.118 31.361 14.399 29.369 13.6219 28.5341 12.5576 28.0243 11.42 27.942L10.813 20.436C10.8075 20.3301 10.7173 20.2487 10.6114 20.2542 10.5158 20.2591 10.4384 20.3337 10.43 20.429L9.521 27.981C9.521 27.981 9.147 31.807 10.865 33.796 12.583 35.785 15.983 35.461 15.983 35.461Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.146 35.461C17.146 35.461 20.546 35.785 22.264 33.796 23.982 31.807 23.608 27.981 23.608 27.981L22.7 20.429C22.6907 20.3234 22.5975 20.2453 22.4918 20.2546 22.3965 20.2631 22.3219 20.3404 22.317 20.436L21.71 27.942C20.5722 28.0246 19.5077 28.5343 18.73 29.369 17.011 31.358 17.146 35.461 17.146 35.461Z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M16.588 29.737C17.9868 28.3037 18.8483 26.4317 19.027 24.437 18.948 22.8502 18.4141 21.3197 17.489 20.028L16.768 12.5C16.7604 12.3942 16.6684 12.3147 16.5627 12.3223 16.4675 12.3292 16.3919 12.4049 16.385 12.5L15.642 20.021C14.6825 21.3353 14.1102 22.8921 13.99 24.515 13.961 27.417 16.588 29.737 16.588 29.737Z",
  fill: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M39.782 35.4C38.024 37.439 38.082 41.539 38.082 41.539 38.082 41.539 41.476 41.766 43.234 39.727 44.992 37.688 44.693 33.872 44.693 33.872 44.693 33.872 41.54 33.362 39.782 35.4Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.15 47.823C44.908 45.785 44.609 41.968 44.609 41.968 44.609 41.968 41.46 41.457 39.7 43.5 37.94 45.543 38 49.635 38 49.635 38 49.635 41.392 49.862 43.15 47.823Z",
  fill: "currentColor"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9 41.557C36.9 41.557 37.034 37.457 35.316 35.464 33.598 33.471 30.437 34.076 30.437 34.076 30.437 34.076 30.063 37.903 31.782 39.892 33.501 41.881 36.9 41.557 36.9 41.557Z",
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M36.824 49.652C36.824 49.652 36.959 45.552 35.24 43.56 33.521 41.568 30.362 42.172 30.362 42.172 30.362 42.172 29.988 46 31.706 47.987 33.424 49.974 36.824 49.652 36.824 49.652Z",
  fill: "currentColor"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M43.158 55.9C44.916 53.861 44.617 50.045 44.617 50.045 44.617 50.045 41.468 49.534 39.71 51.573 37.952 53.612 38.01 57.712 38.01 57.712 38.01 57.712 41.4 57.935 43.158 55.9Z",
  fill: "currentColor"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M30.37 50.245C30.37 50.245 30 54.071 31.714 56.06 33.428 58.049 36.832 57.725 36.832 57.725 36.832 57.725 36.967 53.625 35.248 51.633 33.529 49.641 30.37 50.245 30.37 50.245Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M36.983 33.461C36.983 33.461 37.118 29.361 35.4 27.369 34.6223 26.5343 33.5578 26.0246 32.42 25.942L31.813 18.436C31.8075 18.3301 31.7173 18.2487 31.6114 18.2542 31.5158 18.2591 31.4384 18.3337 31.43 18.429L30.521 25.981C30.521 25.981 30.147 29.807 31.865 31.796 33.583 33.785 36.983 33.461 36.983 33.461Z",
  fill: "currentColor"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M38.146 33.461C38.146 33.461 41.546 33.785 43.264 31.796 44.982 29.807 44.608 25.981 44.608 25.981L43.7 18.429C43.6907 18.3234 43.5975 18.2453 43.4919 18.2546 43.3965 18.2631 43.3219 18.3404 43.317 18.436L42.71 25.942C41.5722 26.0246 40.5077 26.5343 39.73 27.369 38.011 29.358 38.146 33.461 38.146 33.461Z",
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M37.589 27.737C38.9874 26.3036 39.8485 24.4316 40.027 22.437 39.948 20.8502 39.4141 19.3197 38.489 18.028L37.769 10.495C37.7614 10.3892 37.6694 10.3097 37.5637 10.3173 37.4685 10.3242 37.3929 10.3999 37.386 10.495L36.642 18.016C35.6825 19.3303 35.1102 20.8871 34.99 22.51 34.961 25.417 37.589 27.737 37.589 27.737Z",
  fill: "currentColor"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M60.782 35.4C59.024 37.439 59.082 41.539 59.082 41.539 59.082 41.539 62.476 41.766 64.234 39.727 65.992 37.688 65.693 33.872 65.693 33.872 65.693 33.872 62.54 33.362 60.782 35.4Z",
  fill: "currentColor"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M64.15 47.823C65.908 45.785 65.61 41.968 65.61 41.968 65.61 41.968 62.46 41.457 60.7 43.5 58.94 45.543 59 49.635 59 49.635 59 49.635 62.392 49.862 64.15 47.823Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M57.9 41.557C57.9 41.557 58.035 37.457 56.316 35.464 54.597 33.471 51.438 34.076 51.438 34.076 51.438 34.076 51.064 37.903 52.782 39.892 54.5 41.881 57.9 41.557 57.9 41.557Z",
  fill: "currentColor"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M57.824 49.652C57.824 49.652 57.959 45.552 56.24 43.56 54.521 41.568 51.362 42.172 51.362 42.172 51.362 42.172 50.988 46 52.706 47.987 54.424 49.974 57.824 49.652 57.824 49.652Z",
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M64.158 55.9C65.916 53.861 65.618 50.045 65.618 50.045 65.618 50.045 62.469 49.534 60.71 51.573 58.951 53.612 59.01 57.712 59.01 57.712 59.01 57.712 62.4 57.935 64.158 55.9Z",
  fill: "currentColor"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M51.37 50.245C51.37 50.245 51 54.071 52.714 56.06 54.428 58.049 57.832 57.725 57.832 57.725 57.832 57.725 57.967 53.625 56.248 51.633 54.529 49.641 51.37 50.245 51.37 50.245Z",
  fill: "currentColor"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M57.984 33.461C57.984 33.461 58.118 29.361 56.4 27.369 55.6225 26.5341 54.5579 26.0244 53.42 25.942L52.813 18.436C52.8075 18.3301 52.7173 18.2487 52.6114 18.2542 52.5158 18.2591 52.4384 18.3337 52.43 18.429L51.521 25.981C51.521 25.981 51.147 29.807 52.866 31.796 54.585 33.785 57.984 33.461 57.984 33.461Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M59.146 33.461C59.146 33.461 62.546 33.785 64.264 31.796 65.982 29.807 65.608 25.981 65.608 25.981L64.7 18.429C64.6907 18.3234 64.5975 18.2453 64.4918 18.2546 64.3965 18.2631 64.3219 18.3404 64.317 18.436L63.71 25.942C62.5724 26.0243 61.5081 26.5341 60.731 27.369 59.011 29.358 59.146 33.461 59.146 33.461Z",
  fill: "currentColor"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M58.589 27.737C59.9874 26.3036 60.8485 24.4316 61.027 22.437 60.948 20.8502 60.4141 19.3197 59.489 18.028L58.769 10.495C58.7614 10.3892 58.6694 10.3097 58.5637 10.3173 58.4685 10.3242 58.3929 10.3999 58.386 10.495L57.643 18.016C56.6825 19.3299 56.1098 20.8869 55.99 22.51 55.961 25.417 58.589 27.737 58.589 27.737Z",
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M81.782 37.4C80.024 39.439 80.082 43.539 80.082 43.539 80.082 43.539 83.476 43.766 85.234 41.727 86.992 39.688 86.693 35.872 86.693 35.872 86.693 35.872 83.54 35.362 81.782 37.4Z",
  fill: "currentColor"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M85.15 49.823C86.908 47.785 86.61 43.968 86.61 43.968 86.61 43.968 83.46 43.457 81.7 45.5 79.94 47.543 80 51.635 80 51.635 80 51.635 83.392 51.862 85.15 49.823Z",
  fill: "currentColor"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M78.9 43.557C78.9 43.557 79.035 39.457 77.316 37.465 75.597 35.473 72.438 36.076 72.438 36.076 72.438 36.076 72.064 39.903 73.782 41.892 75.5 43.881 78.9 43.557 78.9 43.557Z",
  fill: "currentColor"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M78.824 51.652C78.824 51.652 78.959 47.552 77.24 45.56 75.521 43.568 72.362 44.172 72.362 44.172 72.362 44.172 71.988 48 73.707 49.987 75.426 51.974 78.824 51.652 78.824 51.652Z",
  fill: "currentColor"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M85.158 57.9C86.917 55.861 86.618 52.045 86.618 52.045 86.618 52.045 83.469 51.534 81.71 53.573 79.951 55.612 80.01 59.712 80.01 59.712 80.01 59.712 83.4 59.935 85.158 57.9Z",
  fill: "currentColor"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M72.37 52.245C72.37 52.245 72 56.071 73.714 58.06 75.428 60.049 78.832 59.725 78.832 59.725 78.832 59.725 78.967 55.625 77.249 53.633 75.531 51.641 72.37 52.245 72.37 52.245Z",
  fill: "currentColor"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M78.984 35.461C78.984 35.461 79.118 31.361 77.4 29.369 76.6226 28.5339 75.558 28.0241 74.42 27.942L73.813 20.436C73.8075 20.3301 73.7173 20.2487 73.6114 20.2542 73.5158 20.2591 73.4384 20.3337 73.43 20.429L72.521 27.981C72.521 27.981 72.147 31.807 73.866 33.796 75.585 35.785 78.984 35.461 78.984 35.461Z",
  fill: "currentColor"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M80.146 35.461C80.146 35.461 83.546 35.785 85.264 33.796 86.982 31.807 86.608 27.981 86.608 27.981L85.7 20.429C85.6981 20.3235 85.611 20.2396 85.5055 20.2415 85.4 20.2434 85.3161 20.3305 85.318 20.436L84.711 27.942C83.573 28.0241 82.5084 28.5339 81.731 29.369 80.011 31.358 80.146 35.461 80.146 35.461Z",
  fill: "currentColor"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M79.589 29.737C80.9872 28.3033 81.8485 26.4315 82.028 24.437 81.9487 22.8501 81.4145 21.3195 80.489 20.028L79.769 12.495C79.7614 12.3892 79.6694 12.3097 79.5637 12.3173 79.4685 12.3242 79.3929 12.3999 79.386 12.495L78.643 20.016C77.683 21.3302 77.1103 22.887 76.99 24.51 76.962 27.417 79.589 29.737 79.589 29.737Z",
  fill: "currentColor"
});

var SvgOats = function SvgOats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Crops",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oats.7a3c04b9.svg";
export { ForwardRef as ReactComponent };